import React from "react";
import { Button } from "@smartling-ui/button";
import { useIntl } from "react-intl";
import { GoogleIcon } from "./GoogleIcon";

import messages from "./messages";

type Props = {
    onClick: VoidFunction;
}

export function GoogleButton({ onClick }: Props) {
    const intl = useIntl();

    return (
        <Button
            variant="secondary"
            type="button"
            size="lg"
            fullWidth
            onClick={onClick}
            icon={<GoogleIcon />}
        >

            {intl.formatMessage(messages.buttonSignUpWithGoogle)}
        </Button>
    );
}
